import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { EmergencyBanner } from '@/components/EmergencyBanner';

interface LayoutProps {
  readonly children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isLandingPage = location.pathname === '/';

  if (isLandingPage) {
    return <div className="min-h-screen bg-slate-50 text-slate-900 font-sans">{children}</div>;
  }

  return (
    <div className="flex min-h-screen flex-col bg-base-200 text-base-content">
      <EmergencyBanner />
      <Navbar />
      <Sidebar />
      <main className="flex-grow p-4 md:p-6">{children}</main>
    </div>
  );
}


